export enum BankAccountOperationStatus {
  Unreconciled = 'UNRECONCILED',
  Reconciled = 'RECONCILED',
}

export enum BankAccountOperationSource {
  BankFeed = 'BANK_FEED',
  Manual = 'MANUAL',
}

export enum BankAccountTransferType {
  Incoming = 'INCOMING',
  Outgoing = 'OUTGOING',
}

export enum BankReconciliationActionType {
  ReconciliationCreated = 'ReconciliationCreated',
}

export enum CurrencySaleRevaluationType {
  CurrencySaleGain = 'CURRENCY_SALE_GAIN',
  CurrencySaleLoss = 'CURRENCY_SALE_LOSS',
}

export enum PaymentActivity {
  Created = 'CREATED',
  PaymentReceived = 'PAYMENT_RECEIVED',
  PrepaymentReceived = 'PREPAYMENT_RECEIVED',
  PrepaymentResolved = 'PREPAYMENT_RESOLVED',
}
